<template>
    <div>
        <!-- 传灯祈福法会 -->
        <ChuanDengQiFuDetail :page-data="payload" :next-page="onRoute" v-if="$getSpecialReligiousAssemblyRecord([238]).includes(payload.id)"/>
        <!-- 皈依法会 -->
        <GuiYiDetail :page-data="payload" :next-page="onRoute" v-else-if="$getSpecialReligiousAssemblyRecord([230, 243]).includes(payload.id)" />
    </div>
</template>

<script>
    import ChuanDengQiFuDetail from './components/ChuanDengQiFuDetail'
    import GuiYiDetail from './components/GuiYiDetail'
    export default {
        data () {
            return {
                payload: {}
            }
        },
        mounted () {
            this.getData()
        },
        methods: {
            // 供奉详情
            getData () {
                this.$faWuApi.faHui.getItemData({
                    id: this.$route.query.pId
                }).then(res => {
                    if (res.success) {
                        this.payload = res.data
                    }
                })
            },
            // 跳转下一步
            onRoute () {
                this.$router.push({
                    path: 'reg-record',
                    query: this.$route.query
                })
            }
        },
        components: {
            ChuanDengQiFuDetail,
            GuiYiDetail
        }
    }
</script>